import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { TopchartPageId } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import {
  getDeviceValuesByPageId,
  getDeviceOptionByType,
} from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
const entityType = 'mobile';

const companyFilterParams = {
  // entity_type: entityType,
  // source: 'steamcharts',
  // data_sources: ['newzoo', 'mscience', 'steamcharts', 'npd'],
  // metric: 'pcu',
  // region_type: 'region',
  // regions: ['global'],
  // granularity: 'monthly',
  // start_date: '',
  // end_date: '',
  // page_size: 500,
  // search_name: '',
  // page: 1,
  // source_metric: {
  //   steamcharts: ['pcu'],
  // },
};

// 筛选器value默认值
export const DEFAULT_FILTER_VALUE_COMBINE = {
  [filterKeyMap.DIGITAL_SEGMENT_MULTIPLE]: {
    value: ['All'],
  },
  [filterKeyMap.RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
  [filterKeyMap.REGION]: {
    regions: ['global'],
    markets: ['global'],
    type: 'market',
  },
  [filterKeyMap.DATASOURCESIM]: {
    value: 'sensortower',
    // value: 'appannie',
  },
};

// 筛选器自定义布局列表
export const FILTER_KEY_LIST_COMBINE = [
  filterKeyMap.ROW,
  filterKeyMap.DIGITAL_SEGMENT_MULTIPLE,
  filterKeyMap.RANGE_TIME,
  filterKeyMap.REGION,
  filterKeyMap.DATASOURCESIM,
];

// 筛选器list配置
export const DEFAULT_INPUT_LIST_COMBINE = [
  {
    key: filterKeyMap.ROW,
  },
  {
    key: filterKeyMap.DIGITAL_SEGMENT_MULTIPLE,
    btnNameKey: 'dbi_top_genre',
    optionsOutList: [],
    isNeedHeaderTitle: false,
    marginStyle: '0 10px 10px 0',
  },
  {
    type: filterKeyMap.RANGE_TIME,
    key: filterKeyMap.RANGE_TIME,
    extendFilterType: filterKeyMap.RANGE_TIME_EXTEND_TYPE.singleMonth,
    calendarType: 'month',
    showSelectType: false,
    showShortcut: false,
    default: ['', ''],
  },
  {
    key: filterKeyMap.REGION,
    default: [],
    visible: 1,
    disableNoChina: true,
    entityType,
  },
  {
    key: filterKeyMap.DATASOURCESIM,
    default: [],
    singleType: 'single',
    isSearchItemMargin: true,
    isShowButtonLabel: true,
  },
];

export default {
  MarketProfilMobile: {
    defaultFilterValue: DEFAULT_FILTER_VALUE_COMBINE,
    filterKeyList: FILTER_KEY_LIST_COMBINE,
    defaultInputList: DEFAULT_INPUT_LIST_COMBINE,
  },
};
